export default {
  header: "Join Rock, Paper or Scissors",
  view: "join",
  name: "",
  game: ""
};